<template>
  <div class="contentwrapper">
    <h1 class="heading">Connect your Wallet.</h1>

    <div class="innerContentWrapper">
      <div class="textwrapper">

        <vue-metamask v-if="pleaseConnectWallet"
                      userMessage="msg"
                      @onComplete="onComplete"
        >
        </vue-metamask>

        <template v-if="!pleaseConnectWallet">
          <div class="paragraph">
            Before you start please check if you have a gummy.
            If not, you can <a href="https://www.gummy.link/product/gummy">order it here</a>
          </div>
          <div class="btn" @click="onClickConnectMetaMaskWallet">
            <div class="btncontentwrapper">
              <h3 class="btnfont" >Connect metamask</h3><img src="@/assets/metamask-mini.png" loading="lazy" alt="" class="foximage">
            </div>
          </div>
        </template>

        <template v-if="pleaseConnectWallet && !isMetamaskChecked">
          <p class="paragraph">Please login to your Metamask account in the popup.</p>
        </template>

        <template v-if="isMetamaskChecked">
          <template v-if="!wallet">
            <p class="paragraph">Please setup an ethereum wallet in your metamask.</p>
          </template>
          <template v-if="wallet.type === 'NO_INSTALL_METAMASK'">
            <p class="paragraph">To connect your wallet you need the metamask browser plugin.</p>
            <p class="paragraph">You can download it here:</p>
            <div class="btn" @click="onOpenMetaMaskUrl">
              <div class="btncontentwrapper">
                <h3 class="btnfont" >Download Metamask</h3><img src="@/assets/metamask-mini.png" loading="lazy" alt="" class="foximage">
              </div>
            </div>
          </template>

          <template v-else-if="wallet.type === 'NO_LOGIN'">
            <p class="paragraph">To connect your wallet you need the metamask browser plugin.<br>You can download it here:</p>
            <div class="btn" @click="onClickConnectMetaMaskWallet">
              <div class="btncontentwrapper">
                <h3 class="btnfont" >Connect metamask</h3><img src="@/assets/metamask-mini.png" loading="lazy" alt="" class="foximage">
              </div>
            </div>
          </template>

          <template v-else-if="wallet.type === 'USER_DENIED_ACCOUNT_AUTHORIZATION'">
            <p class="paragraph">Please authorize this web application<br>
              in your metamask wallet and reload this page.</p>
          </template>

          <template v-else-if="wallet.type && isSupportedNetwork">
            <p class="paragraph">
              Your wallet ({{ wallet.metaMaskAddress }}) is connected now.
            </p>
          </template>

          <template v-else-if="wallet.type && !isSupportedNetwork">
            <p class="paragraph">You are using an unsupported network. <br>Please switch to <b>Ethereum mainnet</b>.</p>
          </template>
        </template>
      </div>
      <div class="visualswrapper"><img class="visual" src="@/assets/metamask-logo.png" loading="lazy" alt=""></div>
    </div>
    <p class="paragraph secondary last">The next step will appear <span class="text-span">automatically</span> once you have connected your wallet</p>
  </div>

</template>

<script>
  
  import VueMetamask from 'vue-metamask';
  import { getNetworkDef } from '@/utils/network-utils.js'

  export default {
    props: {
      wallet: Object
    },
    components: {
      VueMetamask
    },
    data() {
      return {
        msg: "This is demo net work",
        isSupportedNetwork: false,
        pleaseConnectWallet: false,
        isMetamaskChecked: false,
        isWalletConnected: false
      }
    },
    methods: {
      onOpenMetaMaskUrl() {
          window.open('https://metamask.io/download.html', '_blank').focus();
      },
      onClickConnectMetaMaskWallet() {
        this.pleaseConnectWallet = true
      },
      onClickNext() {
        console.log('onClickNext')
        this.$emit('next');
      },
      async onComplete(data) {
        console.log(data);
        const wallet = data;
        this.isMetamaskChecked = true;

        //console.log('data:', data)
        //console.log('web3:', data.web3)

        var selectedNetwork = getNetworkDef(data.netID, data.type)
        this.isSupportedNetwork = selectedNetwork;

        this.$emit('walletChange', { wallet: wallet, network: selectedNetwork });
        this.isWalletConnected = selectedNetwork && wallet.metaMaskAddress && wallet.metaMaskAddress.length > 10 ? true : false;
        if(this.isWalletConnected){
          this.$emit('next');
        }
      }
    },
    mounted() {
      console.log("in mounted!!", this.wallet)
      this.pleaseConnectWallet = this.wallet && this.wallet.type && this.wallet.metaMaskAddress;
    }
  }
</script>
